import { createEmiColumnHelper } from "components/table";

const columnHelper = createEmiColumnHelper();

const createModelTaskColumns = ({
	showOperatingMode,
	showSystem,
	customCaptions,
	modelType,
}) => {
	const definitions = [
		{ id: "logo", label: "", sortable: false, width: "110px" },
		// The header's column id drives the sortField sent to the API, and "pos"
		// is the only Order-related value it accepts there. The row body (see
		// displayField below) renders "orderNumber" instead - the stable,
		// gap-free rank the API computes independent of the current sort.
		{ id: "pos", label: "Order", displayField: "orderNumber" },
		{ id: "actionName", label: customCaptions?.actionRequired },
		{ id: "name", label: "Name" },
		...(modelType === "F"
			? [{ id: "assets", label: customCaptions?.asset }]
			: []),
		...(showOperatingMode
			? [{ id: "operatingModeName", label: customCaptions?.operatingMode }]
			: []),
		...(showSystem
			? [{ id: "systemName", label: customCaptions?.system }]
			: []),
		{ id: "roles", label: customCaptions?.rolePlural },
		{ id: "estimatedMinutes", label: "Est Mins" },
		{ id: "intervals", label: customCaptions?.intervalPlural, width: "100px" },
		{ id: "stages", label: customCaptions?.stagePlural },
		{ id: "zones", label: customCaptions?.zonePlural },
		{ id: "arrangements", label: customCaptions?.arrangementPlural },
		{ id: "notes", label: "Notes", sortable: false },
	];

	return {
		// The row body reads cells by these keys directly (rows[col]), separate
		// from the columnDefs below - so displayField can diverge from the
		// column's sort id without touching how sorting works.
		columns: definitions.map(({ id, displayField }) => displayField ?? id),
		columnDefs: columnHelper.columns(
			definitions.map((definition) =>
				columnHelper.accessor(definition.id, {
					header: definition.label,
					enableSorting: definition.sortable !== false,
					meta: { width: definition.width },
				})
			)
		),
	};
};

export default createModelTaskColumns;
